module.exports = __webpack_public_path__ + "img/click.eb9f6b02.png";